import validate from "/unified-client/node_modules/.pnpm/nuxt@3.21.4_@parcel+watcher@2.5.6_@types+node@24.12.2_@vue+compiler-sfc@3.5.33_cac@6.7._46b16e96619e5cfe2cc2b5109133eb96/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/unified-client/middleware/auth.global.ts";
import clear_45notifications_45global from "/unified-client/middleware/clear-notifications.global.ts";
import fullstory_45global from "/unified-client/middleware/fullstory.global.ts";
import intercom_45global from "/unified-client/middleware/intercom.global.ts";
import navigation_45global from "/unified-client/middleware/navigation.global.ts";
import up_45navigation_45global from "/unified-client/middleware/upNavigation.global.ts";
import manifest_45route_45rule from "/unified-client/node_modules/.pnpm/nuxt@3.21.4_@parcel+watcher@2.5.6_@types+node@24.12.2_@vue+compiler-sfc@3.5.33_cac@6.7._46b16e96619e5cfe2cc2b5109133eb96/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  clear_45notifications_45global,
  fullstory_45global,
  intercom_45global,
  navigation_45global,
  up_45navigation_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}